import { render, staticRenderFns } from "./parts-group-preview.vue?vue&type=template&id=0307be50&scoped=true&"
import script from "./parts-group-preview.vue?vue&type=script&lang=ts&"
export * from "./parts-group-preview.vue?vue&type=script&lang=ts&"
import style0 from "./parts-group-preview.vue?vue&type=style&index=0&id=0307be50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0307be50",
  null
  
)

export default component.exports